<template>
  <div class="component">
    <div class="title">
      {{ title }}
    </div>
    <div class="steps" v-if="activeStep <= 2">
      <span class="steps-item" :class="{ active: activeStep === 0 }"></span>
      <span class="steps-item" :class="{ active: activeStep === 1 }"></span>
      <span class="steps-item" :class="{ active: activeStep === 2 }"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Title",
  props: ["title", "activeStep"]
};
</script>

<style scoped lang="scss">
@import "../../../styles/colors";
.title {
  color: $blue;
  font-size: 27px;
  margin-bottom: 15px;
  text-align: center;
  font-family: TTNormsBold, sans-serif;
}
.steps {
  display: flex;
  justify-content: center;
}
.steps-item {
  width: 10px;
  height: 10px;
  background-color: $blue;
  margin: 0 13px;
  border-radius: 5px;
  display: block;
}
.steps-item.active {
  background-color: $green;
}
@media (max-width: 768px) {
  .title {
    font-size: 20px;
    margin: 0 0 20px 0;
  }
}
</style>
